import Box from '@mui/material/Box';
import { toBioHtml } from '@onesource/schemas';
import { FC } from 'react';

import { sanitizeBioHtml } from './sanitize-bio-html';

export { sanitizeBioHtml } from './sanitize-bio-html';

type TBioContentProps = {
  /** Stored bio: rich HTML, or legacy plain text with newlines. */
  html: string;
};

/** Renders a Pro Directory bio. Always sanitized, so it is safe even if the stored value is not. */
export const BioContent: FC<TBioContentProps> = ({ html }) => (
  <Box
    sx={{
      lineHeight: 1.7,
      overflowWrap: 'anywhere',
      '& p': { m: 0, '& + p': { mt: 1.5 } },
      '& ul, & ol': { my: 1, pl: 3 },
      '& a': { color: 'primary.main', textDecoration: 'underline' },
    }}
    dangerouslySetInnerHTML={{ __html: sanitizeBioHtml(toBioHtml(html)) }}
  />
);
